import { render, staticRenderFns } from "./HxeNearestHotelListBlock.vue?vue&type=template&id=4f1fde64&scoped=true"
import script from "./HxeNearestHotelListBlock.vue?vue&type=script&lang=js"
export * from "./HxeNearestHotelListBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1fde64",
  null
  
)

export default component.exports